export default defineNuxtPlugin(() => {


  // 重寫全域 $fetch 的錯誤處理
  const originalFetch = globalThis.$fetch

  globalThis.$fetch = originalFetch.create({
    onResponseError({ response, request, options }) {
      console.log('🚨 [Interceptor] API Error Detected:')
      console.log('🚨 [Interceptor] URL:', request?.toString())
      console.log('🚨 [Interceptor] Status:', response.status)
      console.log('🚨 [Interceptor] Data:', JSON.stringify(response._data))

      // 檢查是否為未授權錯誤
      const isUnauthorized = response.status === 401 ||
          (response._data?.result === false &&
           response._data?.code === 0 &&
           response._data?.message === "Unauthenticated.")

      console.log('🚨 [Interceptor] Is Unauthorized:', isUnauthorized)
      
      if (isUnauthorized) {
        const requestUrl = request?.toString() || ''
        console.log('url ',requestUrl);
        console.log('headers  : ',options.headers);
        // 針對 /api/v3/user 檢查是否設定了 skipAutoLogout 標頭
        if (requestUrl.includes('/check-login')) {
          return
        }

        // 使用新的協調層處理未授權錯誤
        import('~/composables/useAuthHandler').then(({ useAuthHandler }) => {
          const { handleUnauthorized } = useAuthHandler()
          handleUnauthorized()
        })
      }
    }
  })
})